import type { DispatchPanel } from "./DispatchPopover";

/**
 * Whether a double-click on a row should open History on the row's channel.
 *
 * A double-click on a control inside a cell (a checkbox, a button, a link) opens nothing, so it keeps doing what it
 * does. The double-click's first click already moved an open panel to the row, so History already showing the row's
 * channel opens nothing either: `openPanel` would toggle it closed.
 *
 * @param target - The element the double-click landed on.
 * @param open - The panel open now and the channel it shows.
 * @param feedId - The row's channel.
 */
export function doubleClickOpensHistory(
  target: Element,
  open: { panel: DispatchPanel; feedId: string | undefined },
  feedId: string | undefined,
): boolean {
  if (target.closest(CONTROL_SELECTOR)) return false;
  return !(open.panel === "history" && open.feedId === feedId);
}

/** The elements inside a cell that take a click of their own. */
const CONTROL_SELECTOR = "a, button, input, textarea, select, [role='button'], [role='checkbox']";
